<mat-progress-bar *ngIf="isSaving()" mode="indeterminate" class="sticky progress"></mat-progress-bar>
<div class="container-fluid">
  <div class="row">
    <div class="col-10">
      <h2 class="m-1">{{ 'transactionRecieptsModal.title' | translate }}</h2>
    </div>
    <div class="col-2 text-right">
      <button color="primary" mat-raised-button [mat-dialog-close]="true">
        {{ 'close' | translate }}
      </button>
    </div>
  </div>
  <div class="row" [hidden]="isSaving()">
    <div class="container-fluid">
      <div class="row">
        <div class="col pb-4">
        </div>
      </div>

      <div class="row">
        <div class="col pb-4">
          <button *ngIf="this.showCartReceipt" mat-raised-button color="primary" (click)="this.showCartReceipt = false">
            {{ 'home.back' | translate }}
          </button>
          <div class="invoice bg-white shadow-sm mt-3 p-3" *ngIf="this.showCartReceipt">
            <h2 class="border-bottom mb-4">{{ 'transactionInvoicePrint.cartReceipt' | translate }}:</h2>

            <div class="col-12 p-3 border-bottom">
              <span>{{ 'transactionInvoicePrint.authorizationNumber' | translate }}:</span>
              <strong class="d-block"> {{ this.authorizationNumber }} </strong>
            </div>

            <div class="col-12 p-3 border-bottom">
              <span>{{ 'transactionInvoicePrint.cartTransactions' | translate }}:</span>
              <ul>
                <div *ngFor="let item of cartReceiptList">
                  <li *ngIf="item.ProcessName !== null">
                    <strong class="d-block mt-3" [innerHTML]="item.ProcessName | multiLang">
                    </strong>
                  </li>
                </div>
              </ul>
            </div>


            <div class="invoice-content">
              <div class="table-responsive">
                <table class="table table-invoice">
                  <thead>
                    <tr>
                      <th fxHide fxShow.sm fxShow.gt-sm>
                        {{ 'transactionInvoicePrint.cost' | translate }}
                      </th>
                      <th class="text-right" fxHide fxShow.sm fxShow.gt-sm>
                        Costo
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>
                        <strong class="d-block mt-2">{{ 'payment.subtotal' | translate }}</strong>
                        <strong class="d-block mt-2">{{ 'shoppingCart.feeAmount' | translate }}</strong>
                        <hr>
                        <strong class="d-block mt-2 h5">{{ 'shoppingCart.total' | translate }}</strong>
                      </td>
                      <td class="text-right">
                        <strong class="d-block mt-2"> {{ this.subtotalCart | currency }} </strong>
                        <strong class="d-block mt-2"> {{ this.feeAmountCart | currency }} </strong>
                        <hr>
                        <strong class="d-block mt-2 h5"> {{ this.totalCart | currency }} </strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="invoice bg-white shadow-sm mt-3 p-3" *ngIf="!this.showCartReceipt">
            <h2 class="border-bottom mb-4">{{ 'transactionInvoicePrint.invoice' | translate }}</h2>
            <div class="row mx-1 mb-3 border shadow-sm">
              <div class="col-md-6 p-3 border-bottom">
                <span>{{ 'inbox.date' | translate }}:</span>
                <strong class="d-block">{{transationReceiptService.workingInvoice.PaidDate | date:'short'}}</strong>
              </div>
              <div class="col-md-6 p-3 border-bottom">
                <span>{{ 'transactionInvoicePrint.profileName' | translate }}:</span>
                <ng-container *ngIf="this.profile?.Name">
                  <strong class="d-block">{{this.profile?.Name}} {{this.profile?.LastName}}</strong>
                </ng-container>
                <ng-container *ngIf="!this.profile.Name">
                  <strong class="d-block">N/A</strong>
                </ng-container>
              </div>
              <div class="col-md-6 p-3 border-bottom">
                <span>{{ 'transactionInvoicePrint.name' | translate }}:</span>
                <ng-container *ngIf="transationReceiptService.additionalInfo">
                  <strong class="d-block">{{transationReceiptService.additionalInfo.NameOnCard}}</strong>
                </ng-container>
                <ng-container *ngIf="!transationReceiptService.additionalInfo">
                  <strong class="d-block">N/A</strong>
                </ng-container>
              </div>
              <div class="col-md-6 p-3 border-bottom">
                <span>{{ 'transactionInvoicePrint.transactionNumber' | translate }}:</span>
                <strong class="d-block">{{transactionService.itemToEdit.CaseNumber ? transactionService.itemToEdit.CaseNumber : (transactionService.itemToEdit.TempCaseNumber ? transactionService.itemToEdit.TempCaseNumber : transationReceiptService.workingInvoice.UserProcessId)}}</strong>
              </div>
              <div class="col-md-6 p-3 border-bottom">
                <span>{{ 'transactionInvoicePrint.recieptNumber' | translate }}:</span>
                <strong class="d-block">{{transationReceiptService.workingInvoice.ReceiptNO}}</strong>
              </div>
              <div class="col-md-6 p-3 border-bottom">
                <span>{{ 'transactionInvoicePrint.transactionType' | translate }}:</span>
                <strong class="d-block"
                  [innerHTML]="processType?.ProcessName | multiLang"></strong>
              </div>
              <div class="col-md-6 p-3 border-bottom">
                <span>{{ 'transactionInvoicePrint.authorizationNumber' | translate }}:</span>
                <strong class="d-block" [innerHTML]="'Crédito Aplicado'"
                  *ngIf="this.authorizationNumber == 'applied-credit'">
                </strong>
                <strong class="d-block" [innerHTML]="'test-auth'" *ngIf="this.authorizationNumber == 'test-auth'">
                </strong>
                <div class="d-flex"
                  *ngIf="this.authorizationNumber !== 'test-auth' && this.authorizationNumber !== 'applied-credit'">
                  <strong [innerHTML]="this.authorizationNumber"></strong>
                  <!-- <mat-icon class="ml-2" style="cursor: pointer;" [matTooltip]="tooltipTxt" matTooltipPosition="after"
                    (click)="onShowCartReceipt()">
                    help
                  </mat-icon> -->
                </div>
              </div>
            </div>

            <div class="invoice-content">
              <table class="table table-invoice">
                <thead>
                  <tr>
                    <th fxHide fxShow.sm fxShow.gt-sm>{{ 'transactionInvoicePrint.cost' | translate }}</th>
                    <th class="text-center" fxHide fxShow.sm fxShow.gt-sm>
                      {{ 'transactionInvoicePrint.charge' | translate }}</th>
                    <th class="text-center" fxHide fxShow.sm fxShow.gt-sm>
                      {{ 'transactionInvoicePrint.amount' | translate }}</th>
                    <th fxHide fxShow.sm fxShow.gt-sm></th>
                    <th class="text-center" fxHide fxShow.sm fxShow.gt-sm>
                      {{ 'transactionInvoicePrint.quantity' | translate }}</th>
                    <th class="text-right" fxHide fxShow.sm fxShow.gt-sm>
                      {{ 'transactionInvoicePrint.total' | translate }}</th>
                  </tr>
                </thead>
                <tbody *ngIf="!this.transactionService.itemToEdit.HasDynamicCosts">

                  <tr *ngFor="let item of transationReceiptService.workingInvoice.Costs">
                    <td fxHide fxShow.xs>
                      <strong>{{ 'transactionInvoicePrint.cost' | translate }}: </strong>
                      <span *ngIf="item?.name">
                        {{ item?.name | multiLang }}
                      </span>
                      <span *ngIf="!item?.name" [innerHtml]="item?.CostDescription | multiLang">
                      </span>
                      <strong>{{ 'transactionInvoicePrint.amount' | translate }}: </strong>
                      <ng-container *ngIf="item.FixedAmount == 0 || item.FixedAmount == null">
                        {{item.Amount | currency}}
                      </ng-container>
                      <ng-container *ngIf="item.FixedAmount > 0">
                        {{item.FixedAmount | currency}}
                      </ng-container>
                      <br>
                      <strong>{{ 'transactionInvoicePrint.quantity' | translate }}: </strong> {{item.Qty}}
                    </td>

                    <td class="col-md-6" fxHide fxShow.sm fxShow.gt-sm>
                      <div *ngIf="transationReceiptService.workingInvoice.InvoiceHasCosts">
                        <span [innerHTML]="item.CostDescription | multiLang"></span>
                      </div>
                      <div *ngIf="!transationReceiptService.workingInvoice.InvoiceHasCosts">
                        <div *ngIf="item?.name">
                          {{ item?.name | multiLang }}
                        </div>
                        <div *ngIf="!item?.name" [innerHtml]="item?.CostDescription | multiLang">
                        </div>
                      </div>
                    </td>

                    <td class="col-md-2 text-center" fxHide fxShow.sm fxShow.gt-sm>
                      <ng-container *ngIf="transationReceiptService.workingInvoice.InvoiceHasCosts">
                        <ng-container *ngIf="item.FixedAmount == 0 || item.FixedAmount == null">
                          {{item.Amount | currency}}
                        </ng-container>
                        <ng-container *ngIf="item.FixedAmount > 0">
                          {{item.FixedAmount | currency}}
                        </ng-container>
                      </ng-container>
                      <ng-container *ngIf="!transationReceiptService.workingInvoice.InvoiceHasCosts">
                        <ng-container *ngIf="item?.cost">
                          {{item?.name | multiLang}}
                        </ng-container>
                        <ng-container *ngIf="!item?.cost">
                          {{item?.Amount + transationReceiptService.workingInvoice?.FeeAmount}}
                        </ng-container>
                      </ng-container>
                    </td>
                    <td class="col-md-1 text-center" fxHide fxShow.sm fxShow.gt-sm>x</td>

                    <td class="col-md-1 text-center" fxHide fxShow.sm fxShow.gt-sm>
                      {{item.Qty}}
                    </td>
                    <td class="col-md-1 text-right" fxHide fxShow.sm fxShow.gt-sm>
                      <ng-container *ngIf="transationReceiptService.workingInvoice.InvoiceHasCosts">
                        <ng-container *ngIf="item.FixedAmount == 0 || item.FixedAmount == null">
                          {{item.Amount * item.Qty | currency}}
                        </ng-container>
                        <ng-container *ngIf="item.FixedAmount > 0">
                          {{item.FixedAmount | currency}}
                        </ng-container>
                      </ng-container>
                      <ng-container *ngIf="!transationReceiptService.workingInvoice.InvoiceHasCosts">
                        <ng-container *ngIf="item?.cost">
                          {{item.cost * item.Qty | currency}}
                        </ng-container>
                        <ng-container *ngIf="!item?.cost">
                          {{item?.Amount + transationReceiptService.workingInvoice?.FeeAmount}}
                        </ng-container>

                      </ng-container>
                    </td>
                  </tr>

                  <ng-container *ngIf="(this.toggleInitialPayment || this.initialPayment > 0) && this.showInitialPaymentAmount">
                    <tr *ngFor="let item of this.initialPaymentDetails">
                      <td class="col-md-1 text-left" fxHide fxShow.sm fxShow.gt-sm>
                        {{ 'payment.transactionCost' | translate}}</td>
                      <td class="col-md-1 text-center" fxHide fxShow.sm fxShow.gt-sm></td>
                      <td class="col-md-1 text-right" fxHide fxShow.sm fxShow.gt-sm></td>
                      <td class="col-md-1 text-right" fxHide fxShow.sm fxShow.gt-sm></td>
                      <td class="col-md-1 text-right" fxHide fxShow.sm fxShow.gt-sm></td>
                      <td class="col-md-1 text-right" fxHide fxShow.sm fxShow.gt-sm>
                        {{item.InitialPaymentAmount | currency}}</td>
                    </tr>
                  </ng-container>

                  <ng-container *ngIf="this.marbeteCost">
                    <tr>
                      <td class="col-md-1 text-left" fxHide fxShow.sm fxShow.gt-sm>
                        {{ 'payment.inscriptionCost' | translate }}</td>
                      <td class="col-md-1 text-center" fxHide fxShow.sm fxShow.gt-sm></td>
                      <td class="col-md-1 text-right" fxHide fxShow.sm fxShow.gt-sm></td>
                      <td class="col-md-1 text-right" fxHide fxShow.sm fxShow.gt-sm></td>
                      <td class="col-md-1 text-right" fxHide fxShow.sm fxShow.gt-sm> {{ this.marbeteCost| currency }}
                      </td>
                    </tr>
                  </ng-container>

                  <ng-container *ngIf="this.infractionDetail.length > 0">
                    <tr *ngFor="let item of infractionDetail">
                      <td class="col-md-1 text-left" fxHide fxShow.sm fxShow.gt-sm>
                        {{ 'payment.infractionTicket' | translate }} - {{ item.numero_de_boleto }}</td>
                      <td class="col-md-1 text-center" fxHide fxShow.sm fxShow.gt-sm></td>
                      <td class="col-md-1 text-right" fxHide fxShow.sm fxShow.gt-sm></td>
                      <td class="col-md-1 text-right" fxHide fxShow.sm fxShow.gt-sm></td>
                      <td class="col-md-1 text-right" fxHide fxShow.sm fxShow.gt-sm> {{ item.monto | currency }} </td>
                    </tr>
                  </ng-container>

                  <ng-container *ngIf="hasRadiationMachineCost()">
                    <tr>
                      <td class="col-md-1 text-left" fxHide fxShow.sm fxShow.gt-sm>{{ 'payment.radiationMachineCost' | translate }}</td>
                      <td class="col-md-1 text-center" fxHide fxShow.sm fxShow.gt-sm></td>
                      <td class="col-md-1 text-center" fxHide fxShow.sm fxShow.gt-sm>
                         {{radiationMachineIndividualCost | currency}}
                      </td>
                      <td class="col-md-1 text-center" fxHide fxShow.sm fxShow.gt-sm></td>
                      <td class="col-md-1 text-center" fxHide fxShow.sm fxShow.gt-sm>{{radiationMachineCount }}</td>
                      <td class="col-md-1 text-right" fxHide fxShow.sm fxShow.gt-sm>
                        {{additionalCost | currency}}
                      </td>
                    </tr>
                  </ng-container>

                  <ng-container *ngIf="additionalCost > 0 && !hasRadiationMachineCost()">
                    <tr>
                      <td class="col-md-1 text-left" fxHide fxShow.sm fxShow.gt-sm>{{ 'payment.additionalCost' | translate }}</td>
                      <td class="col-md-1 text-center" fxHide fxShow.sm fxShow.gt-sm></td>
                      <td class="col-md-1 text-center" fxHide fxShow.sm fxShow.gt-sm></td>
                      <td class="col-md-1 text-center" fxHide fxShow.sm fxShow.gt-sm></td>
                      <td class="col-md-1 text-center" fxHide fxShow.sm fxShow.gt-sm></td>
                      <td class="col-md-1 text-right" fxHide fxShow.sm fxShow.gt-sm>
                        {{additionalCost | currency}}
                      </td>
                    </tr>
                  </ng-container>

                  <tr>
                    <td class="col-md-1 text-left" fxHide fxShow.sm fxShow.gt-sm>
                      <b class="h5 fw-bold" style="color: #000000;">{{ 'payment.subtotal' | translate }}</b>
                    </td>
                    <td class="col-md-1 text-center" fxHide fxShow.sm fxShow.gt-sm></td>
                    <td class="col-md-1 text-right" fxHide fxShow.sm fxShow.gt-sm></td>
                    <td class="col-md-1 text-right" fxHide fxShow.sm fxShow.gt-sm></td>
                    <td class="col-md-1 text-right" fxHide fxShow.sm fxShow.gt-sm></td>
                    <td class="col-md-1 text-right" fxHide fxShow.sm fxShow.gt-sm>
                      <b class="h5 fw-bold" style="color: #000000;">
                        {{ (transationReceiptService.workingInvoice.CalculatedTotalAmount -
                        transationReceiptService.workingInvoice.FeeAmount) | currency}}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td class="col-md-1 text-left" fxHide fxShow.sm fxShow.gt-sm>
                      {{'payment.convenienceFee' | translate}}</td>
                    <td class="col-md-1 text-center" fxHide fxShow.sm fxShow.gt-sm></td>
                    <td class="col-md-1 text-right" fxHide fxShow.sm fxShow.gt-sm></td>
                    <td class="col-md-1 text-right" fxHide fxShow.sm fxShow.gt-sm></td>
                    <td class="col-md-1 text-right" fxHide fxShow.sm fxShow.gt-sm></td>
                    <td class="col-md-1 text-right" fxHide fxShow.sm fxShow.gt-sm>
                      {{ transationReceiptService.workingInvoice.FeeAmount | currency}}
                    </td>
                  </tr>
                </tbody>

                <tbody *ngIf="this.transactionService.itemToEdit.HasDynamicCosts">
                  <tr *ngFor="let item of transationReceiptService.workingInvoice.Costs">
                    <td fxHide fxShow.xs>
                      <strong>{{ 'transactionInvoicePrint.cost' | translate }}: </strong>
                      <span [innerHTML]="item.CostDescription | multiLang"></span>
                      <br>
                      <strong>{{ 'transactionInvoicePrint.charge' | translate }}: </strong>
                      <ng-container *ngIf="item.FixedAmount == 0 || item.FixedAmount == null">
                        {{item.Amount | currency}}
                      </ng-container>
                      <ng-container *ngIf="item.FixedAmount > 0">
                        {{item.FixedAmount | currency}}
                      </ng-container>
                      <br>
                      <strong>{{ 'transactionInvoicePrint.quantity' | translate }}: </strong> {{item.Qty}}
                    </td>

                    <td class="col-md-6" fxHide fxShow.sm fxShow.gt-sm>
                      <div *ngIf="transationReceiptService.workingInvoice.InvoiceHasCosts">
                        <span [innerHTML]="item.CostDescription | multiLang"></span>
                      </div>
                      <div *ngIf="!transationReceiptService.workingInvoice.InvoiceHasCosts">
                        <div *ngIf="item?.name">
                          {{ item?.name | multiLang }}
                        </div>
                        <div *ngIf="!item?.name" [innerHtml]="item?.CostDescription | multiLang">
                        </div>
                      </div>
                    </td>
                    <td class="col-md-2 text-right" fxHide fxShow.sm fxShow.gt-sm>
                      <ng-container *ngIf="transationReceiptService.workingInvoice.InvoiceHasCosts">
                        <ng-container *ngIf="item.FixedAmount == 0 || item.FixedAmount == null">
                          {{item.Amount | currency}}
                        </ng-container>
                        <ng-container *ngIf="item.FixedAmount > 0">
                          {{item.FixedAmount | currency}}
                        </ng-container>
                      </ng-container>
                      <ng-container *ngIf="!transationReceiptService.workingInvoice.InvoiceHasCosts">
                        <ng-container *ngIf="item?.cost">
                          {{item.name | multiLang}}
                        </ng-container>
                        <ng-container *ngIf="!item?.cost">
                          {{item.Amount + transationReceiptService.workingInvoice.FeeAmount}}
                        </ng-container>
                      </ng-container>
                    </td>
                    <td class="col-md-1 text-center" fxHide fxShow.sm fxShow.gt-sm>x</td>

                    <td class="col-md-1 text-center" fxHide fxShow.sm fxShow.gt-sm>
                      {{item.Qty}}
                    </td>
                    <td class="col-md-1 text-right" fxHide fxShow.sm fxShow.gt-sm>
                      <ng-container *ngIf="transationReceiptService.workingInvoice.InvoiceHasCosts">

                        <ng-container *ngIf="item.FixedAmount == 0 || item.FixedAmount == null">
                          {{item.Amount * item.Qty | currency}}
                        </ng-container>
                        <ng-container *ngIf="item.FixedAmount > 0">
                          {{item.FixedAmount | currency}}
                        </ng-container>
                      </ng-container>
                      <ng-container *ngIf="!transationReceiptService.workingInvoice.InvoiceHasCosts">
                        <ng-container *ngIf="item?.cost">
                          {{item.cost * item.Qty | currency}}
                        </ng-container>
                        <ng-container *ngIf="!item?.cost">
                          {{item?.Amount + transationReceiptService.workingInvoice?.FeeAmount}}
                        </ng-container>

                      </ng-container>
                    </td>
                  </tr>
                  <tr>
                    <td fxHide fxShow.sm fxShow.gt-sm>{{ 'payment.subtotal' | translate }}</td>
                    <td fxHide fxShow.sm fxShow.gt-sm></td>
                    <td fxHide fxShow.sm fxShow.gt-sm></td>
                    <td fxHide fxShow.sm fxShow.gt-sm></td>
                    <td fxHide fxShow.sm fxShow.gt-sm></td>
                    <td fxHide fxShow.sm fxShow.gt-sm class="text-right">
                      {{transationReceiptService.workingInvoice.CalculatedTotalAmount -
                      transationReceiptService.workingInvoice.FeeAmount | currency}}
                    </td>
                  </tr>
                  <tr>
                    <td fxHide fxShow.xs>
                      {{ 'transactionInvoicePrint.convenienceFee' | translate }}:
                      {{transationReceiptService.workingInvoice.FeeAmount | currency}}
                    </td>
                    <td fxHide fxShow.sm fxShow.gt-sm>{{ 'transactionInvoicePrint.convenienceFee' | translate }}</td>
                    <td fxHide fxShow.sm fxShow.gt-sm></td>
                    <td fxHide fxShow.sm fxShow.gt-sm></td>
                    <td fxHide fxShow.sm fxShow.gt-sm></td>
                    <td fxHide fxShow.sm fxShow.gt-sm class="text-right">
                      {{transationReceiptService.workingInvoice.FeeAmount | currency}}
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="row border-top">
                <div class="col text-right p-4"><span class="mr-4">{{ 'transactionInvoicePrint.total' | translate
                    }}:</span><strong class="text-lg">{{transationReceiptService.workingInvoice.CalculatedTotalAmount |
                    currency}}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

